export enum Modals {
  LABEL = 'LABEL',
  MULTI_PACKAGE = 'MULTI_PACKAGE',
}
